module.exports = __webpack_public_path__ + "img/qy (49).ffb544dd.jpg";